import { render } from "./ConveniqCommand.vue?vue&type=template&id=0d245e6e&scoped=true"
import script from "./ConveniqCommand.vue?vue&type=script&lang=js"
export * from "./ConveniqCommand.vue?vue&type=script&lang=js"

import "./ConveniqCommand.vue?vue&type=style&index=0&id=0d245e6e&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d245e6e"]])

export default __exports__